"use strict";
const makeEnv = require('../../config/environment');
// FAMLY_ENV is declared in build.sh, otherwise undefined which will fall back inside `makeEnv`
module.exports = makeEnv(process.env.FAMLY_ENV);
